import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@joint/plus/joint-plus.css';
import './styles.scss';
import { init } from './src/app';
import { setTheme } from '@joint/plus';

init();

setTheme('light');
